import React from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import { render } from 'react-dom';
import Root from 'main/root';
import { render as Routes } from 'router';
import { createStore } from 'util/redux';
import reducers from 'reducers';

const store = createStore(reducers.reducers, reducers.actions);

export default function init() {
    render(
        <Provider store={store}>
            <Router forceRefresh={globals.config.is_cms_enabled}>
                <Route match="/" render={props => (
                    <Root {...props}>
                        <Routes/>
                    </Root>
                )}/>
            </Router>
        </Provider>,
        window.root,
    );
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/main/app.js